class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    // Selectors
    this.mainElement = '[js-selected-products-wrapper]';
    this.productWrapperSelector = '[js-product-wrapper]';
    this.selectProductBtnSelector = '[js-select-product-btn]';
    this.quantityInputSelector = '[js-quantity-input]';
    this.incrementBtnSelector = '[js-quantity-increment]';
    this.decrementBtnSelector = '[js-quantity-decrement]';
    this.selectionBoxSelector = '[js-selection-box]';
    this.selectionBoxListSelector = '[js-selection-box-list]';
    this.bundleTypeSelector = '[js-bundle-type-selector]';
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.totalRegularPrice = '[js-bundle-regular-price]';
    this.totalDiscountedPriceSelector = '[js-bundle-discounded-price]';
    this.totalStrikePriceSelector = '[js-bundle-strike-price]';
    this.remainingProductCountWrap = '[js-selection-remaining-count-wrap]';
    this.bundleDiscountAmountWrap = '[js-selection-discount-amount-wrap]';
    this.bundleDiscountAmount = '[js-selection-discount-amount]';
    this.productPopupDetailBtn = '[js-product-card-detail-icon]';
    this.bundlePopupWraper = this.querySelector('[js-hb-bundle-popup-wrap]');
    this.emptyATCButton = this.querySelector('[js-bundle-addtocart-btn-empty]');
    this.selectionCountWrappers = this.querySelector('[js-selection-count-wrapper]');
    this.selectionCounts = this.querySelectorAll('[js-selection-count]');
    this.addToCartBtns = this.querySelectorAll('[js-bundle-addToCart-btn]');
    this.bundleDisountInitialMsgs = this.querySelectorAll('[js-selection-initial-message]');
    this.bundleDisountFinalMsgs = this.querySelectorAll('[js-selection-discount-message]');
    this.bundleProgressbar = this.querySelector('[js-progress-bar]');
    this.closeDrawerBtn = this.querySelectorAll('[js-bundle-products-list-cross-btn]');
    this.openDrawerBtn = this.querySelectorAll('[js-selection-drawer-open]');
    this.bundlePlanSelector = document.querySelector('#bundle_selling_plan');
    this.oneTimePriceSelector = '.one-time-purchase-price span';
    this.subscriptionPriceSelector = '.subscription-price span';

    // State
    this.discount = 0;
    this.progressbarPercentage = 0;
    this.totalDiscountedPrice = 0;
    this.totalBox = 4;
    this.products = [];

    // Event Listeners
    this.querySelectorAll('input[name="bundle_purchase_option"]').forEach(radio => {
      radio.addEventListener('change', () => {
        this.updateProductSellingPlans();
        this.updateStatus();
        this.priceHandler();
      });
    });

    this.addEventListener('click', (event) => {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
        if (selectProductBtn.contains(event.target)) {
          const parent = selectProductBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
          parent.classList.add('selected');
          this.addProductToBox(parent);
          this.updateStatus();
        }
      });
      this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
        if (incrementBtn.contains(event.target)) {
          const parent = incrementBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
          this.addProductToBox(parent);
        }
      });
      this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
        if (decrementBtn.contains(event.target)) {
          const parent = decrementBtn.closest(this.productWrapperSelector);
          const currentProductId = Number(parent.dataset.productId);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          if (Number(quantityField.value) > 0) {
            quantityField.stepDown();
          }
          this.removeProductFromBox(currentProductId, parent);
        }
      });
      this.closeDrawerBtn.forEach(crossBtn => {
        if (crossBtn.contains(event.target)) {
          this.querySelector('[js-all-products-wrapper]')?.classList.remove('drawer-open');
        }
      });
      this.openDrawerBtn.forEach(openBtn => {
        if (openBtn.contains(event.target)) {
          this.querySelector('[js-all-products-wrapper]')?.classList.add('drawer-open');
        }
      });
      this.querySelectorAll(this.productPopupDetailBtn).forEach(popupDetainBtn => {
        if (popupDetainBtn.contains(event.target)) {
          const parent = popupDetainBtn.closest(this.productWrapperSelector);
          const productHandle = parent.dataset.productHandle;
          this.renderProduct(productHandle, popupDetainBtn);
        }
      });
    });

    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.addEventListener('click', () => {
        this.addToCartBtns.forEach(btn => {
          btn.classList.add('loading');
          btn.querySelector('.loading__spinner')?.classList.remove('hidden');
        });
        const products = this.products.map(item => ({
          id: item.id,
          quantity: 1,
          selling_plan: item.sellingplanId,
          properties: {
            _bundle_discount: this.discount,
            _bundle_product: true,
            _bundle_id: new Date().getTime(),
            _parent_container_id: this.dataset.productContainerId
          }
        }));
        this.addToCart(products);
      });
    });

    // Initialization
    this.createBox(this.totalBox);
    this.bindPlanSelectListeners();
    this.bindSubscribeButtonListeners();
    this.cartUpdateEvent();
    const subscriptionRadio = this.querySelector('input[name="bundle_purchase_option"][value="subscription"]');
    if (subscriptionRadio && subscriptionRadio.checked) {
      this.updateProductSellingPlans();
    } else {
      this.initializeSellingPlan();
    }
    this.priceHandler();
  }

  cartUpdateEvent() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.bindPlanSelectListeners();
        this.bindSubscribeButtonListeners();
      });
    } else {
      console.warn('Cart update subscription not available, skipping.');
    }
  }

  bindSubscribeButtonListeners() {
    if (!this._buttonListeners) this._buttonListeners = new WeakMap();
    const buttons = this.cart?.querySelectorAll('.subscribe-plan-btn') || [];
    buttons.forEach(button => {
      const old = this._buttonListeners.get(button);
      if (old) button.removeEventListener('click', old);
      const newListener = () => {
        const wrapper = button.closest('.subscription-wrapper');
        if (!wrapper) return;
        const loadingMsg = wrapper.querySelector('.loading-message');
        if (loadingMsg) {
          loadingMsg.style.display = 'block';
          loadingMsg.innerText = 'Loading';
        }
        button.style.display = 'none';
        let dots = 0;
        wrapper._loadingInterval = setInterval(() => {
          dots = (dots + 1) % 4;
          loadingMsg.innerText = 'Loading' + '.'.repeat(dots);
        }, 500);
        const select = wrapper.querySelector('.plan-select');
        if (select) {
          select.selectedIndex = 1;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      this._buttonListeners.set(button, newListener);
      button.addEventListener('click', newListener);
    });
  }

  initializeSellingPlan() {
    const planSelector = document.getElementById('bundle_selling_plan');
    if (planSelector && planSelector.options.length > 0) {
      const selectedPlanName = planSelector.options[planSelector.selectedIndex]?.text || '';
      document.querySelectorAll('.hb-bundle__alpha--item').forEach(item => {
        const sellingPlansJSON = item.getAttribute('data-selling-plans');
        if (!sellingPlansJSON || sellingPlansJSON === '{}') {
          item.removeAttribute('data-product-sellingplan');
          return;
        }
        try {
          const sellingPlans = JSON.parse(sellingPlansJSON);
          if (sellingPlans && typeof sellingPlans === 'object' && Object.keys(sellingPlans).length > 0) {
            const matchingPlanId = sellingPlans[selectedPlanName];
            if (matchingPlanId) {
              item.setAttribute('data-product-sellingplan', matchingPlanId);
            } else {
              console.warn(`No matching plan ID for "${selectedPlanName}" in:`, sellingPlans);
              item.removeAttribute('data-product-sellingplan');
            }
          } else {
            console.warn('sellingPlans is not a valid object:', sellingPlansJSON);
            item.removeAttribute('data-product-sellingplan');
          }
        } catch (error) {
          console.error('Invalid JSON in data-selling-plans:', sellingPlansJSON, error);
          item.removeAttribute('data-product-sellingplan');
        }
      });
    }
  }

  updateProductSellingPlans() {
    const subscriptionRadio = this.querySelector('input[name="bundle_purchase_option"][value="subscription"]');
    const isSubscriptionSelected = subscriptionRadio && subscriptionRadio.checked;
    const planSelector = document.getElementById('bundle_selling_plan');
    const selectedPlanName = planSelector && planSelector.options[planSelector.selectedIndex]?.text || '';

    this.products = this.products.map(product => {
      const productWrapper = this.querySelector(`[data-product-id="${product.id}"]`);
      if (!productWrapper) return product;
      let newSellingPlanId = null;
      if (isSubscriptionSelected) {
        const sellingPlansJSON = productWrapper.getAttribute('data-selling-plans');
        if (sellingPlansJSON && sellingPlansJSON !== '{}') {
          try {
            const sellingPlans = JSON.parse(sellingPlansJSON);
            if (sellingPlans && typeof sellingPlans === 'object' && Object.keys(sellingPlans).length > 0) {
              newSellingPlanId = Number(sellingPlans[selectedPlanName]) || null;
            }
          } catch (error) {
            console.error('Invalid JSON in data-selling-plans:', sellingPlansJSON, error);
          }
        }
      }
      return {
        ...product,
        sellingplanId: newSellingPlanId,
      };
    });
    this.priceHandler();
  }

  bindPlanSelectListeners() {
    if (!this._planListeners) this._planListeners = new WeakMap();
    document.querySelectorAll('.plan-select').forEach(select => {
      const oldListener = this._planListeners.get(select);
      if (oldListener) select.removeEventListener('change', oldListener);
      const newListener = this.onPlanChange.bind(this);
      this._planListeners.set(select, newListener);
      select.addEventListener('change', newListener);
    });
    if (this.bundlePlanSelector) {
      const planSelector = document.getElementById('bundle_selling_plan');
      if (planSelector) {
        planSelector.addEventListener('change', () => {
          const selectedPlanName = planSelector.options[planSelector.selectedIndex]?.text || '';
          document.querySelectorAll('.hb-bundle__alpha--item').forEach(item => {
            const sellingPlansJSON = item.getAttribute('data-selling-plans');
            if (!sellingPlansJSON || sellingPlansJSON === '{}') {
              item.removeAttribute('data-product-sellingplan');
              return;
            }
            try {
              const sellingPlans = JSON.parse(sellingPlansJSON);
              if (sellingPlans && typeof sellingPlans === 'object' && Object.keys(sellingPlans).length > 0) {
                const matchingPlanId = sellingPlans[selectedPlanName];
                if (matchingPlanId) {
                  item.setAttribute('data-product-sellingplan', matchingPlanId);
                } else {
                  console.warn(`No matching plan ID for "${selectedPlanName}" in:`, sellingPlans);
                  item.removeAttribute('data-product-sellingplan');
                }
              } else {
                console.warn('sellingPlans is not a valid object:', sellingPlansJSON);
                item.removeAttribute('data-product-sellingplan');
              }
            } catch (error) {
              console.error('Invalid JSON in data-selling-plans:', sellingPlansJSON, error);
              item.removeAttribute('data-product-sellingplan');
            }
          });
          this.updateProductSellingPlans();
        });
      } else {
        console.error('Plan selector element not found');
      }
    }
  }

  onPlanChange(event) {
    const selectedPlanId = event.target.value;
    const line = event.target.closest('.subscription-wrapper')?.dataset.line;
    const select = event.target;
    const wrapper = select.closest('.subscription-wrapper');
    const button = wrapper?.querySelector('.subscribe-plan-btn');
    const selectorUI = wrapper?.querySelector('.subscription-selector');
    const loadingMsg = wrapper?.querySelector('.loading-message');
    const qtyInput = this.cart?.querySelector(`input[name="updates[]"][data-index="${line}"]`);
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    if (selectedPlanId === '') {
      if (selectorUI) selectorUI.style.display = 'none';
      if (loadingMsg) {
        loadingMsg.style.display = 'block';
        loadingMsg.innerText = 'Loading';
      }
      let dots = 0;
      wrapper._loadingInterval = setInterval(() => {
        dots = (dots + 1) % 4;
        loadingMsg.innerText = 'Loading' + '.'.repeat(dots);
      }, 500);
      setTimeout(() => {
        clearInterval(wrapper._loadingInterval);
        delete wrapper._loadingInterval;
        if (loadingMsg) loadingMsg.style.display = 'none';
        if (button) button.style.display = 'block';
      }, 1000);
      this.updateCartLine(parseInt(line), quantity, selectedPlanId);
      return;
    }
    if (line) {
      this.updateCartLine(parseInt(line), quantity, selectedPlanId);
    }
  }

  async updateCartLine(line, quantity, selling_plan) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity, selling_plan })
      });
      if (!res.ok) throw new Error('Cart change failed');
      const sections = this.cart?.getSectionsToRender().map(section => section.id) || [];
      const sectionsUrl = `${window.location.pathname}?sections=${sections.join(',')}`;
      const htmlRes = await fetch(sectionsUrl);
      const htmlData = await htmlRes.json();
      const parsedState = {
        sections: htmlData,
        id: selling_plan
      };
      if (this.cart && typeof this.cart.renderContents === 'function') {
        this.cart.renderContents(parsedState);
        this.bindPlanSelectListeners();
        this.bindSubscribeButtonListeners();
      } else {
        console.warn('Cart drawer not ready or renderContents is missing.');
      }
    } catch (error) {
      console.error('Error updating cart line:', error);
    }
  }

  createBox(number) {
    const selectionBoxList = this.querySelector(this.selectionBoxListSelector);
    if (selectionBoxList) {
      selectionBoxList.innerHTML = '';
      let productbox = '';
      for (let i = 0; i < number; i++) {
        productbox += `
          <div class="hb-bundle__item" data-index="${i}" js-selection-box>
            <div class="hb-bundle__product-content">
              <div class="hb-bundle__product-media">
                <img src="https://cdn.shopify.com/s/files/1/0588/2298/3812/files/Frame_1000007168.png?v=1741586646" alt="">
              </div>
              <div class="hb-bundle__product-title">Fruit Punch</div>
            </div>
            <div class="hb-bundle__empty-selection">
              <svg width="88" height="107" viewBox="0 0 88 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="85.75" height="105" rx="7" stroke="#213478" stroke-opacity="0.2" stroke-width="2" stroke-dasharray="4 4"/>
                <path d="M23 87.9485L23.7628 21.9588V20.2423L37.1116 17L63.2372 20.2423L64 87.9485L37.1116 91L23 87.9485Z" fill="#D9D9D9" fill-opacity="0.35"/>
              </svg>
            </div>
          </div>
        `;
      }
      selectionBoxList.insertAdjacentHTML('beforeend', productbox);
    }
  }

  addProductToBox(parent) {
    const imageUrl = parent.dataset.productImageUrl;
    const productId = Number(parent.dataset.productId);
    const title = parent.dataset.productTitle;
    const price = parseFloat(parent.dataset.productPrice) || 0;
    const subscriptionRadio = this.querySelector('input[name="bundle_purchase_option"][value="subscription"]');
    const isSubscriptionSelected = subscriptionRadio && subscriptionRadio.checked;
    let sellingplanId = null;

    if (isSubscriptionSelected) {
      const sellingPlansJSON = parent.getAttribute('data-selling-plans');
      if (sellingPlansJSON && sellingPlansJSON !== '{}') {
        try {
          const planSelector = document.getElementById('bundle_selling_plan');
          const selectedPlanName = planSelector && planSelector.options[planSelector.selectedIndex]?.text || '';
          const sellingPlans = JSON.parse(sellingPlansJSON);
          if (sellingPlans && typeof sellingPlans === 'object' && Object.keys(sellingPlans).length > 0) {
            sellingplanId = Number(sellingPlans[selectedPlanName]) || null;
          }
        } catch (error) {
          console.error('Invalid JSON in data-selling-plans:', sellingPlansJSON, error);
        }
      }
    }

    this.products.push({
      id: productId,
      imageUrl,
      title,
      price,
      quantity: 1,
      sellingplanId
    });

    this.updateDiscount();
    if (this.products.length) {
      this.fillProductInSelectionBox(this.products);
    }
    this.priceHandler();
  }

  fillProductInSelectionBox(products) {
    this.createBox(this.totalBox);
    products.forEach((item, index) => {
      const box = this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`);
      if (box) {
        box.innerHTML = '';
        box.classList.add('selected');
        box.setAttribute('js-selection-box', '');
        box.setAttribute('data-product-id', item.id);
        box.setAttribute('data-product-price', item.price);
        box.insertAdjacentHTML('beforeend', `
          <div class="hb-bundle__product-content">
            <div class="hb-bundle__product-media">
              <img src="${item.imageUrl}" alt="${item.title}">
            </div>
            <div class="hb-bundle__product-title">${item.title}</div>
          </div>
          <div class="hb-bundle__empty-selection">
            <svg width="88" height="107" viewBox="0 0 88 107" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="85.75" height="105" rx="7" stroke="#213478" stroke-opacity="0.2" stroke-width="2" stroke-dasharray="4 4"/>
              <path d="M23 87.9485L23.7628 21.9588V20.2423L37.1116 17L63.2372 20.2423L64 87.9485L37.1116 91L23 87.9485Z" fill="#D9D9D9" fill-opacity="0.35"/>
            </svg>
          </div>
        `);
      }
    });
    this.updateStatus();
  }

  priceHandler() {
    let totalBundlePrice = 0;
    let totalOriginalPrice = 0;
    this.products.forEach(item => {
      const price = parseFloat(item.price) || 0;
      const originalPrice = parseFloat(item.originalPrice) || price; // Fallback to price if originalPrice missing
      totalBundlePrice += price;
      totalOriginalPrice += originalPrice;
    });

    // Update bundle discount (0% for 1, 10% for 2, 15% for 3, 20% for 4)
    this.updateDiscount();
    this.totalDiscountedPrice = ((100 - parseFloat(this.discount)) * totalOriginalPrice) / 100;

    // Check if subscription is selected
    const subscriptionRadio = this.querySelector('input[name="bundle_purchase_option"][value="subscription"]');
    const isSubscriptionSelected = subscriptionRadio && subscriptionRadio.checked;

    // Subscription price: always bundle discount + 10% off for .subscription-price span
    const subscriptionPrice = this.totalDiscountedPrice * 0.9;

    // Update one-time purchase price (bundle discounts only)
    const oneTimePriceElements = this.querySelectorAll(this.oneTimePriceSelector);
    oneTimePriceElements.forEach(element => {
      if (this.products.length > 0) {
        element.style.display = 'inline';
        element.innerText = `$${this.totalDiscountedPrice.toFixed(2)}`;
      } else {
        element.style.display = 'none';
      }
    });

    // Update subscription price (always show subscription price)
    const subscriptionPriceElements = this.querySelectorAll(this.subscriptionPriceSelector);
    subscriptionPriceElements.forEach(element => {
      if (this.products.length > 0) {
        element.style.display = 'inline';
        element.innerText = `$${subscriptionPrice.toFixed(2)}`;
      } else {
        element.style.display = 'none';
      }
    });

    // Update bundle prices
    const regularPriceElements = this.querySelectorAll(this.totalRegularPrice);
    regularPriceElements.forEach(element => {
      element.innerText = `$${totalOriginalPrice.toFixed(2)}`;
    });

    const discountPriceElements = this.querySelectorAll(this.totalDiscountedPriceSelector);
    discountPriceElements.forEach(element => {
      if (this.products.length > 0) {
        element.style.display = 'inline';
        element.innerText = isSubscriptionSelected
          ? `$${subscriptionPrice.toFixed(2)}`
          : `$${this.totalDiscountedPrice.toFixed(2)}`;
      } else {
        element.style.display = 'none';
      }
    });


    if (isSubscriptionSelected) {
      const strikePriceElement = this.querySelectorAll(this.totalStrikePriceSelector);
      strikePriceElement.forEach(element => {
        element.innerText = `$${this.totalDiscountedPrice.toFixed(2)}`;
      });
    } else {
      if (this.products.length > 1) {
        const strikePriceElement = this.querySelectorAll(this.totalStrikePriceSelector);
        strikePriceElement.forEach(element => {
          element.innerText = `$${totalOriginalPrice.toFixed(2)}`;
        });
      }else{
        const strikePriceElement = this.querySelectorAll(this.totalStrikePriceSelector);
        strikePriceElement.forEach(element => {
          element.innerText = ``;
        });
      }
    }
  }

  updateStatus() {
    // Update discount messages
    if (this.products.length > 1) {
      this.bundleDisountFinalMsgs.forEach(msg => msg.classList.remove('hidden'));
      this.bundleDisountInitialMsgs.forEach(msg => msg.classList.add('hidden'));
    } else {
      this.bundleDisountFinalMsgs.forEach(msg => msg.classList.add('hidden'));
      this.bundleDisountInitialMsgs.forEach(msg => msg.classList.remove('hidden'));
    }

    // Update discount message content
    if (this.products.length === 2) {
      this.bundleDisountFinalMsgs.forEach(msg => {
        msg.innerHTML = "🎉 Congrats! You unlocked: <strong>10% off</strong>";
      });
    } else if (this.products.length === 3) {
      this.bundleDisountFinalMsgs.forEach(msg => {
        msg.innerHTML = "🎉 Congrats! You unlocked: <strong>15% off + Free Shipping</strong>";
      });
    } else if (this.products.length > 3) {
      this.bundleDisountFinalMsgs.forEach(msg => {
        msg.innerHTML = "🎉 Congrats! You unlocked: <strong>20% off + Free Shipping</strong>";
      });
    }

    // Disable selection buttons when max products reached
    if (this.products.length === 4) {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(item => item.classList.add('disabled'));
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.add('disabled'));
      this.mobileBundleDrawerHandler();
    } else {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(item => item.classList.remove('disabled'));
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.remove('disabled'));
    }

    // Show/hide add-to-cart buttons
    if (this.products.length >= 1) {
      this.addToCartBtns.forEach(btn => btn.classList.remove('hidden'));
      this.emptyATCButton?.classList.add('hidden');
      const oneTimeContainer = this.querySelector('.hb-bundle__one-time');
      if (oneTimeContainer) oneTimeContainer.classList.remove('hidden');
      const subscribedPriceContainer = this.querySelector('.hb-bundle__subscribed-price');
      if (subscribedPriceContainer) subscribedPriceContainer.classList.remove('hidden');
    } else {
      this.addToCartBtns.forEach(btn => btn.classList.add('hidden'));
      this.emptyATCButton?.classList.remove('hidden');
      const oneTimeContainer = this.querySelector('.hb-bundle__one-time');
      if (oneTimeContainer) oneTimeContainer.classList.add('hidden');
      const subscribedPriceContainer = this.querySelector('.hb-bundle__subscribed-price');
      if (subscribedPriceContainer) subscribedPriceContainer.classList.add('hidden');
    }

    // Enable/disable radio buttons and subscription plan dropdown
    const subscriptionRadio = this.querySelector('input[name="bundle_purchase_option"][value="subscription"]');
    const oneTimeRadio = this.querySelector('input[name="bundle_purchase_option"][value="onetime"]');
    const subscriptionPlan = document.querySelector('#bundle-subscription-plan');

    if (subscriptionRadio && oneTimeRadio) {
      if (this.products.length > 0) {
        subscriptionRadio.disabled = false;
        oneTimeRadio.disabled = false;
        if (!subscriptionRadio.checked && !oneTimeRadio.checked) {
          oneTimeRadio.checked = true;
        }
      } else {
        subscriptionRadio.disabled = true;
        oneTimeRadio.disabled = true;
        subscriptionRadio.checked = false;
        oneTimeRadio.checked = false;
      }

      if (subscriptionPlan && this.bundlePlanSelector) {
        if (subscriptionRadio.checked && this.products.length > 0) {
          subscriptionPlan.style.display = 'block';
          this.bundlePlanSelector.disabled = false;
        } else {
          subscriptionPlan.style.display = 'none';
          this.bundlePlanSelector.disabled = true;
        }
      }
    }

    // Update selection count
    this.selectionCounts.forEach(count => {
      count.innerHTML = `(${this.products.length}/${this.totalBox})`;
    });

    // Update pricing option class
    const pricingOption = this.querySelector('.hb-bundle__pricing-option-1');
    if (pricingOption) {
      if (this.products.length === 1) {
        pricingOption.classList.add('one-product-added');
      } else {
        pricingOption.classList.remove('one-product-added');
      }
    }

    this.updateProductSellingPlans();
    this.priceHandler();
  }

  removeProductFromBox(id, parent) {
    const otherProducts = this.products.filter(product => product.id !== id);
    const currentProducts = this.products.filter(product => product.id === id);
    currentProducts.splice(0, 1);
    if (currentProducts.length === 0) {
      parent.classList.remove('selected');
    }
    this.products = [...currentProducts, ...otherProducts];
    this.fillProductInSelectionBox(this.products);
    this.updateDiscount();
    this.priceHandler();
  }

  updateDiscount() {
    if (this.products.length === 2) {
      this.discount = parseFloat(this.querySelector('[js-hb-bundle-price-percent-1]')?.value) || 10;
    } else if (this.products.length === 3) {
      this.discount = parseFloat(this.querySelector('[js-hb-bundle-price-percent-2]')?.value) || 15;
    } else if (this.products.length === 4) {
      this.discount = parseFloat(this.querySelector('[js-hb-bundle-price-percent-3]')?.value) || 20;
    } else {
      this.discount = 0;
    }
  }

  updateStep() {
    this.querySelectorAll(`${this.bundleTypeSelector} .progress__box`).forEach(progressBox => {
      progressBox.classList.remove('is-active');
    });
    for (let i = 1; i <= this.products.length; i++) {
      this.querySelectorAll(`${this.bundleTypeSelector}[data-value="${i}"]`).forEach(bundleType => {
        const progressBox = bundleType.querySelector('.progress__box');
        if (progressBox) {
          progressBox.classList.add('is-active');
        }
      });
    }
  }

  updateProgressbar() {
    this.progressbarPercentage = 0;
    if (this.products.length === 1) {
      this.progressbarPercentage = 13;
    } else if (this.products.length === 2) {
      this.progressbarPercentage = 38;
    } else if (this.products.length === 3) {
      this.progressbarPercentage = 63;
    } else if (this.products.length === 4) {
      this.progressbarPercentage = 100;
    }
    if (this.bundleProgressbar) {
      this.bundleProgressbar.style.width = `${this.progressbarPercentage}%`;
    }
  }

  async addToCart(products) {
    const requestBody = {
      items: products
    };
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      requestBody.sections = cartDrawer.getSectionsToRender().map(section => section.id);
    }

    try {
      const resp = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await resp.json();
      this.addToCartBtns.forEach(btn => {
        btn.classList.remove('loading');
        btn.querySelector('.loading__spinner')?.classList.add('hidden');
      });
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      }
      this.bindPlanSelectListeners();
      this.bindSubscribeButtonListeners();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      this.resetBundleSelections();
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  }

  resetBundleSelections() {
    this.products = [];
    this.createBox(this.totalBox);
    this.querySelectorAll(this.productWrapperSelector).forEach(wrapper => {
      wrapper.classList.remove('selected');
      const quantityField = wrapper.querySelector(this.quantityInputSelector);
      if (quantityField) quantityField.value = 0;
    });
    this.querySelectorAll(this.selectProductBtnSelector).forEach(btn => btn.classList.remove('disabled'));
    this.querySelectorAll(this.incrementBtnSelector).forEach(btn => btn.classList.remove('disabled'));
    this.bundleDisountInitialMsgs.forEach(msg => msg.classList.remove('hidden'));
    this.bundleDisountFinalMsgs.forEach(msg => msg.classList.add('hidden'));
    if (this.bundleProgressbar) this.bundleProgressbar.style.width = '0%';
    this.querySelectorAll(`${this.bundleTypeSelector} .progress__box`).forEach(progressBox => {
      progressBox.classList.remove('is-active');
    });
    this.priceHandler();
    this.updateStatus();
  }

  mobileBundleDrawerHandler() {
    const addedAnyProduct = this.querySelectorAll(`${this.selectionBoxSelector}.selected`).length;
    if (window.innerWidth < 767) {
      const wrapper = this.querySelector('[js-all-products-wrapper]');
      if (wrapper) {
        if (addedAnyProduct) {
          wrapper.classList.add('drawer-open');
        } else {
          wrapper.classList.remove('drawer-open');
        }
      }
    }
  }

  async renderProduct(productHandle, popupDetainBtn) {
    try {
      popupDetainBtn.querySelector('.hb_product-card__icon .loading__spinner')?.classList.remove('hidden');
      popupDetainBtn.querySelector('.hb_product-card__icon svg')?.classList.add('hide');
      const response = await fetch(`${location.origin}/${productHandle}?view=product-details`);
      const html = await response.text();
      const html_ = new DOMParser().parseFromString(html, 'text/html');
      const productGrid = html_.querySelector('.hb_bundle_popup__wrapper');
      if (productGrid && this.bundlePopupWraper) {
        const targetElement = this.querySelector('.hb_bundle_popup__wrapper');
        if (targetElement) {
          targetElement.innerHTML = productGrid.innerHTML;
          this.bundlePopupWraper.classList.add('active');
        }
      }
      document.dispatchEvent(new CustomEvent('bundlePopupClose:init'));
      document.dispatchEvent(new CustomEvent('bundlePopupAccordion:init'));
      document.dispatchEvent(new CustomEvent('bundlePopupSlider:init'));
      document.dispatchEvent(new CustomEvent('bundlePopupATB:init'));
      document.dispatchEvent(new CustomEvent('bundlePopupMetaIconSlider:init'));
      document.dispatchEvent(new CustomEvent('initializeMarqueeIfMobile:init'));
      document.dispatchEvent(new CustomEvent('initializeNutritionFactsPopup:init'));
      document.dispatchEvent(new CustomEvent('video-popup:init'));
    } catch (error) {
      console.error('Error fetching product details:', error);
    } finally {
      popupDetainBtn.querySelector('.hb_product-card__icon .loading__spinner')?.classList.add('hidden');
      popupDetainBtn.querySelector('.hb_product-card__icon svg')?.classList.remove('hide');
    }
  }
}

customElements.define('bundle-builder', BundleBuilder);

document.addEventListener('DOMContentLoaded', () => {
  const bundleSection = document.querySelector('.hb-bundle');
  const bundleSectionAlpha = document.querySelector('.hb-bundle__alpha--gird');
  if (window.innerWidth <= 768 && bundleSection && bundleSectionAlpha) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const visibleHeight = entry.intersectionRect.height;
          if (entry.isIntersecting && visibleHeight >= 170) {
            bundleSection.classList.add('sticky-visible');
          } else {
            bundleSection.classList.remove('sticky-visible');
          }
        });
      },
      { threshold: buildThresholdList() }
    );
    observer.observe(bundleSectionAlpha);
  }

  function buildThresholdList() {
    let thresholds = [];
    for (let i = 0; i <= 1.0; i += 0.01) {
      thresholds.push(i);
    }
    return thresholds;
  }
});